var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-page" },
    [
      _c(
        "b-container",
        [
          _c("h1", [_vm._v("Wie funktioniert's?")]),
          _vm._v(" "),
          _c("b-img", {
            attrs: { src: "/img/how-to.png", fluid: "", alt: "Prozessablauf" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }